import React from 'react';
import { Modal as AntModal } from 'antd';

interface ModalProps {
  title: string;
  open: boolean;
  children: React.ReactNode;
  footer?: React.ReactNode;
  onClose?: () => void;
  width?: number;
  closable?: boolean;
  destroyOnClose?: boolean;
}

function Modal({
  title,
  open,
  children,
  footer,
  width,
  onClose,
  closable,
  destroyOnClose,
}: ModalProps): React.ReactElement {
  return (
    <AntModal
      title={title}
      open={open}
      footer={footer}
      width={width}
      maskClosable={closable}
      keyboard={closable}
      destroyOnClose={destroyOnClose}
      closable={closable}
      onCancel={onClose}
      centered={true}
    >
      {children}
    </AntModal>
  );
}

export default Modal;
